import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { getEnvSettings } from "../../app/hostBasedSettings";
import { AppThunk } from "../store";


const workflowManagerUrl = getEnvSettings().workflowManagerUrl;


interface KeyValuePair {
    key: string;
    value: string;
}

interface IBlenderMessagesState {
	setDataMessage: string,
}

const initialState: IBlenderMessagesState = {
	setDataMessage: '',
}

export const blenderApiSlice = createSlice({
	name: 'workflowManager',
	initialState: initialState,
	reducers: {
		setDataMessage: (state, action: PayloadAction<string>) => {
			state.setDataMessage = action.payload
		},
	}
});

export const {
	setDataMessage,
} = blenderApiSlice.actions;

export const setConversationData = (token: string, conversationId: string, data: KeyValuePair[]): AppThunk => async (dispatch) => {
    const url = `${workflowManagerUrl}/api/conversation/${conversationId}/setData`;
    const headers = {
		Authorization: `Bearer ${token}`,
		'Content-Type': 'application/json',
	};
    const response = await fetch(url, {
        method: 'POST',
        headers: headers,
        body: JSON.stringify(data)
    });

    if (response.ok) {
        dispatch(setDataMessage('Success'));
    } else {
        dispatch(setDataMessage('Failed'));
    }
}